import { useEffect } from "react";

import {
    AnchorContentsResponse,
    PaidLandingPersonaTypes
} from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePageProps } from "./jira-software-page";
import { JiraSoftwarePagePaidLpJswAnchor } from "./paid-lp-jsw-anchor";

export interface JiraSoftwarePageAnchorLpJswOperationsProps
    extends JiraSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
}

export const JiraSoftwarePageAnchorLpJswOperations = (
    pageProps: JiraSoftwarePageAnchorLpJswOperationsProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJiraExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);
    const pageId = "anchor-lp-jsw-team-operations";

    return (
        <JiraSoftwarePagePaidLpJswAnchor
            {...pageProps}
            pageId={pageId}
            persona={pageProps.persona as PaidLandingPersonaTypes}
            pageVariant="operations"
        />
    );
};
